import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppLoaderService {

  private isLoading = new Subject<boolean>();
  isLoading$ = this.isLoading.asObservable();

  constructor() {
   }

  start(){
    this.isLoading.next(true);
  }

  close(){
    this.isLoading.next(false);
  }


}
